import { LayoutProps, AuthLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { Container, Content, Wrapper } from './AuthLayout.styled'

export type AuthLayoutSegments = 'header' | 'content' | 'footer'
type InternalLayoutProps = LayoutProps<AuthLayoutSegments>

export const AuthSegment: React.FC<AuthLayoutSegmentProps> = ({ children }) => <>{children}</>

const AuthLayout = ({ segments }: InternalLayoutProps) => {
  return (
    <Container>
      {segments?.header}
      <Content>
        <Wrapper>{segments?.content}</Wrapper>
      </Content>
      {segments?.footer}
    </Container>
  )
}

export default withLayout(AuthLayout)
